import { Box, Card, Grid, Typography } from '@mui/material';
import SectionCard from 'lib/common/GeneralComponents/TenderModal/Components/SectionCard';
import { Portfolio, PortfolioValidation } from 'lib/types/models';
import React, { useState } from 'react';

import UpdateValidations from './UpdateValidations';

const Validations: React.FC<{
  portfolio: Portfolio;
  onPortfolioUpdated?: () => void;
}> = ({ portfolio, onPortfolioUpdated }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <>
      <SectionCard
        title="Validaciones"
        chipLabel="Grupos a los que pertenece este portafolio"
        tooltip={
          'Las validaciones se aplican en distintos procesos, como la ejecución de un motor de riesgo para verificar que el contrato esté firmado y en estado "Completado". Solo se considerarán los portafolios sujetos a validación según cada grupo de validación.'
        }
        canEdit={true}
        onEditClick={() => setShowEditModal(true)}
      >
        {portfolio.portfolioValidations?.length &&
        portfolio.portfolioValidations.length > 0 ? (
          <Grid container spacing={1}>
            {portfolio.portfolioValidations.map((v: PortfolioValidation) => (
              <Grid item xs={6} key={`${v.type}-${v.id}`}>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 1.5,
                    borderColor: 'divider',
                    backgroundColor: 'grey.100',
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      p: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      color="text.primary"
                      sx={{ fontSize: '0.85rem' }}
                    >
                      {v.type}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: '0.65rem' }}
                    >
                      {v.description ?? 'Sin descripción'}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="caption">
            El portafolio no esta asociado a ningún grupo de validaciones.
          </Typography>
        )}
      </SectionCard>
      <UpdateValidations
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        portfolio={portfolio}
        onPortfolioUpdated={onPortfolioUpdated}
      />
    </>
  );
};

export default Validations;
